export default "__VITE_ASSET__BLtdpI6c__"